import { gql } from "@apollo/client";

import type { Brand, Product, Variant, Allergen } from "@shared/types/graphqlGenerated";

type VariantSplinter = Pick<
  Variant,
  "id" | "emersonVariantId" | "descriptor" | "imagesNew" | "sku" | "servingsPerContainer" | "isNew"
>;

type BrandSplinter = Pick<Brand, "id" | "name">;

type ProductSplinter = Pick<
  Product,
  | "id"
  | "_legacyId"
  | "brandName"
  | "shortDescription"
  | "emersonDescription"
  | "warnings"
  | "emersonWarnings"
  | "dosageInstructions"
  | "name"
  | "slug"
  | "variantCount"
  | "anySimilarProductAvailable"
  | "servingSize"
  | "servingUnit"
  | "otherIngredients"
  | "dosageAmount"
  | "dosageFrequency"
  | "eqpLevel"
>;

type AllergenSplinter = Pick<Allergen, "id" | "name">;

interface EmersonCatalogProductWithVariantOpen extends ProductSplinter {
  brand: BrandSplinter;
  allergens: AllergenSplinter[];
  variants: VariantSplinter[];
  availableOrMasterVariant: VariantSplinter;
}

const EMERSON_CATALOG_PRODUCT_WITH_VARIANT_OPEN = gql`
  fragment EmersonCatalogProductWithVariantOpen on Product {
    id
    _legacyId
    name
    slug
    variantCount
    shortDescription
    emersonDescription
    warnings
    emersonWarnings
    dosageInstructions
    servingSize
    servingUnit
    otherIngredients
    dosageAmount
    dosageFrequency
    anySimilarProductAvailable
    eqpLevel
    availableOrMasterVariant {
      id
      emersonVariantId
      descriptor
      imagesNew(filters: $filters)
      image
      sku
      servingsPerContainer
      isNew
    }
    brand {
      id
      name
    }
    allergens {
      id
      name
    }

    variants {
      id
      emersonVariantId
      descriptor
      imagesNew(filters: $filters)
      image
      sku
      servingsPerContainer
      isNew
    }
  }
`;

export { type EmersonCatalogProductWithVariantOpen, EMERSON_CATALOG_PRODUCT_WITH_VARIANT_OPEN };
